import { useTranslation } from "react-i18next";
import { getTranslatedLabel } from "../../../utils/helpers";

const InputFiledRHF = (props: any) => {
  const { t } = useTranslation();

  const { register, formField, errors } = props;
  const label = getTranslatedLabel(formField.translations);

  /**
   * css variable.
   */
  const styles = errors[formField.name] ? "border border-danger" : "";

  return (
    <>
      <input
        {...register}
        type={formField.type}
        name={formField.name}
        className={`form-control Input ${styles}`}
      />

      {errors[formField.name] && (
        <div className="validation-errors-text-size text-danger mt-1 ms-2">
          {errors[formField.name]?.message
            ? errors[formField.name].message
            : t("dynamic-form.required", { param: label })}
        </div>
      )}
    </>
  );
};

export default InputFiledRHF;
